<template>
    <div v-if="cargando">
    <div class="row">
      <div class="col-md-12 text-center">
        <h3>
          Cargando
          <i class="fa fa-spin fa-spinner"></i>
        </h3>
      </div>
    </div>
  </div>
  <div v-else>
     <b-container fluid>
      <b-row>
        <b-col md="2">
          <b-form-group horizontal label="Orden" class="mb-0">
            <b-input-group>
              <b-form-select v-model="orden" slot="append" @input="listPerception">
                <option :value="'asc'">Más Antiguo</option>
                <option :value="'desc'">Más Reciente</option>
              </b-form-select>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="8">
          <div class="col-md-12 text-center">
            <b-button variant="secondary" @click="listPerception">
              <i class="fa fa-sync-alt"></i>
            </b-button>
          </div>
        </b-col>
        <b-col md="2">
          <b-form-group horizontal label="Mostrar" class="mb-0">
            <b-input-group>
              <b-form-select v-model="limite" slot="append" @input="listPerception">
                <option :value="10">10</option>
                <option :value="25">25</option>
                <option :value="50">50</option>
                <option :value="100">100</option>
              </b-form-select>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <br>
      <b-table
        responsive
        small
        striped
        outlined
        :items="perceptions"
        :fields="perceptions_fields"
      >
      <template slot="index" slot-scope="row">
          {{ row.index+1 }}
      </template>
      <template slot="receptor" slot-scope="row">
          <template
            v-if="row.item.idReceptor && row.item.idReceptor.length && row.item.idReceptor.length == 11"
          >{{row.item.idReceptor}} - {{row.item.receiver.razonSocial}}</template>
          <template
            v-else-if="row.item.receiver && row.item.receiver.tipo && row.item.receiver.tipo == 0"
          >{{row.item.idReceptor}} - {{row.item.receiver.razonSocial}}</template>
      </template>
      <template slot="importeTotal" slot-scope="row">
            <template v-if="row.item.monedaTotalCobrado=='PEN'">S/</template>
            <template v-else-if="row.item.monedaTotalCobrado=='USD'">$</template>
            <template v-else>{{ row.item.monedaTotalCobrado }}</template>
            {{ row.item.importeTotalCobrado }}
      </template>
      <template slot="estado" slot-scope="row">
        <template v-if="row.item.emitido==1 && row.item.baja==1">
            <div>
            <span class="badge badge-dark">
                Baja
                <i class="fa fa-ban"></i>
            </span>
            </div>
        </template>
        <template v-else-if="row.item.emitido==3 && row.item.baja==0">
            <div>
            <span class="badge badge-info">
                Baja pendiente
                <i class="fa fa-ban"></i>
            </span>
            </div>
        </template>
        <template v-else>
            <div v-if="row.item.emitido==1">
            <span class="badge badge-success">
                Emitido
                <i class="fa fa-check"></i>
            </span>
            </div>
            <div v-else-if="row.item.emitido==0">
            <span class="badge badge-warning">
                Procesando
                <i class="fa fa-spin fa-spinner"></i>
            </span>
            </div>
            <div v-else-if="row.item.emitido==2">
            <span class="badge badge-danger">
                Rechazado
                <i class="fa fa-times"></i>
            </span>
            </div>
            <div v-else-if="row.item.emitido==6">
            <span class="badge badge-info">
                Procesando OSE
                <i class="fa fa-times"></i>
            </span>
            </div>
        </template>
      </template>
      <template slot="acciones" slot-scope="row">
          <b-button variant="ligth" @click="viewPdf(row.item)"><i class="fa fa-tv text-dark"></i></b-button>
          <b-button @click="setPerception(row.item)" v-b-modal.sendfacturaemail1 v-b-tooltip.hover><i title="Enviar por Mail" class="fa fa-envelope"></i></b-button>
          <b-button @click="downloadPdf(row.item)" v-b-tooltip.hover><i title="Descargar PDF" class="fa fa-file-pdf"></i></b-button>
          <b-button v-if="row.item.emitido==0" class="disabled" :disabled="true" v-b-tooltip.hover><i title="Descargar XML" class="fa fa-file-code"></i></b-button>
          <b-button v-else @click="downloadXml(row.item)" v-b-tooltip.hover><i title="Descargar XML" class="fa fa-file-code"></i></b-button>
          <b-button v-if="row.item.emitido==0 || row.item.emitido==3" class="disabled" :disabled="true"><i title="Descargar CDR" class="fa fa-file-archive"></i></b-button>
          <b-button v-else @click="downloadCdr(row.item)"><i title="Descargar CDR" class="fa fa-file-archive"></i></b-button>
      </template>
      </b-table>
     </b-container>
        <b-row> 
            <b-col cols="9">
              <div>
                <p>Mostrando del {{desde}} al {{hasta}} de un total de {{total}} registros</p>
              </div>
            </b-col> 
            <b-col cols="12" sm="5" md="5" lg="4" xl=3>
              <b-pagination
                  :total-rows="total"
                  v-model="currentPage"
                  @input="listPerception"
                  :per-page="limite"
                  align="center"
              ></b-pagination>
            </b-col>
        </b-row>
     <b-modal id="sendfacturaemail1" title="Enviar por Correo" v-model="previacorreo">
        <div role="group">
          <label for="inputLive">Correos:</label>
          <b-form-input v-model="recipients" type="email" @keyup.enter="sendMail(perception)"></b-form-input>
          <b-form-text
            style="font-size: small !important; color: #ea0909 !important"
          >Ingresa un correo ó varios separados por comas (,)</b-form-text>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-btn
            v-if="!sendcorreo"
            size="sm"
            class="float-right"
            variant="primary"
            @click="sendMail(perception)"
          >Enviar</b-btn>
          <b-btn v-else size="sm" class="float-right" variant="secondary">
            <i class="fa fa-spin fa-spinner"></i> Enviando...
          </b-btn>
        </div>
      </b-modal>
      <b-modal
        id="prevmodal"
        size="lg"
        title="Vista Previa"
        cancel-title="Cerrar"
        v-model="previewmodal"
      >
        <template v-if="cargandopdf2">
          <div class="text-center">
            <h3>
              <i class="fa fa-spin fa-spinner"></i>
            </h3>Cargando vista previa
          </div>
        </template>
        <template v-else>
          <template v-if="pdfobject !==''">
            <b-embed :src="'data:application/pdf;base64,'+ pdfobject" allowfullscreen></b-embed>
          </template>
        </template>
      </b-modal>
      <vue-snotify></vue-snotify>
  </div>
</template>

<script>
import axios from 'axios'
import download from "downloadjs";
    export default {
        name: 'PercepcionConsulta',
        data: () => {
            return {
                cargando: false,
                orden: "desc",
                limite: 15,
                perceptions: [],
                perceptions_fields: [
                    // { key: "index", label: "" },
                    { key: "serie", label: "Serie", sortable: true },
                    { key: "numero", label: "Numero", sortable: true },
                    { key: "fechaEmision", label: "Emisión", sortable: true },
                    { key: "receptor", label: "Receptor", sortable: true },
                    { key: "importeTotal", label: "Total Gravado", sortable: true },
                    { key: "estado", label: "Estado", sortable: true },
                    { key: "acciones", label: "Acciones" }
                ],
                currentPage: 1,
                previacorreo: false,
                perception: {},
                recipients: "",
                sendcorreo: false,
                cargandopdf: false,
                cargandopdf2: false,
                pdfobject: "",
                previewmodal: false,
                // reloadLocal: {
                //   reload: false,
                //   preview: ""
                // },
                total: 0.00,
                desde: 0.00,
                hasta: 0.00, 
            }
        },
        mounted() {
            this.listPerception()
        },
        methods: {
          setPerception: function(data) {
            this.previacorreo = true;
            this.perception = data;
          },
          sendMail: function(data) {
              this.previacorreo = true;
              this.sendcorreo = true;
              axios
                .post(process.env.VUE_APP_API_URL + "percepcion/mail", {
                  token: this.$store.getters.userToken,
                  id: data.idPercepcion,
                  mail: this.recipients
                })
                .then(
                  response => (
                    (this.previacorreo = false),
                    (this.sendcorreo = false),
                    this.$snotify.success(response.data.msg, "Exito")
                  )
                )
                .catch(
                  error => (
                    (this.previacorreo = false),
                    (this.sendcorreo = false),
                    this.$snotify.error(error.response.data.response, "Error")
                  )
                );
            },
            downloadXml: function(data) {
              let xml = "";
              let file = "";
              let name = data.serie + "-" + data.numero + ".zip";
              let tag = document.createElement("i");
              this.cargandopdf = true;
              tag.classList.add("fa", "fa-spin", "fa-spinner");
              this.$swal({
                title: "Obteniendo XML",
                content: tag,
                icon: "info",
                buttons: false,
                dangerMode: false
              });
              axios
                .post(process.env.VUE_APP_API_URL + "percepcion/xml", {
                  token: this.$store.getters.userToken,
                  idpercepcion: data.idPercepcion
                })
                .then(
                  response => (
                    (xml = response.data.response.xml),
                    (file = "data:application/zip;base64," + xml),
                    this.downloadxml(file, name, xml),
                    this.$swal.close()
                  )
                )
                .catch(error =>
                  this.$snotify.error("Error al descargar el archivo", "Error")
                );
            },
            downloadxml: function(file, name, xml) {
              if (xml != null) {
                download(file, name, "application/zip");
              } else {
                this.$snotify.error(
                  "El documento aun no tiene constancia porque esta en proceso!",
                  "Error"
                );
              }
            },
            downloadCdr: function (data){
                let tag = document.createElement('i')
                tag.classList.add('fa','fa-spin', 'fa-spinner')
                let name = 'CDR-' + data.serie + '-' + data.numero + '.zip'
                let file = 'data:application/pdf;base64,'+ data.pdf
                this.cargandocdr = true
                this.$swal({
                    title: 'Procesando Descarga',
                    content: tag,
                    icon: 'info',
                    buttons: false,
                    dangerMode: false
                })
              axios
              .post(process.env.VUE_APP_API_URL + 'percepcion/cdr',{
                  token: this.$store.getters.userToken,
                  idpercepcion: data.idPercepcion
              })
              .then(response => (
                  file = 'data:application/zip;base64,'+ response.data.msg.xml,
                  this.cargandocdr = false,
                  download(file, name,'application/zip'),
                  this.$swal.close()
              ))
              .catch(error => {
                this.$snotify.error(error.response.data.msg, 'Error'),
                this.$swal.close()
              })
            },
            viewPdf: function(data) {
              (this.previewmodal = true),
                (this.pdfobject = ""),
                (this.cargandopdf2 = true);
              axios
                .post(process.env.VUE_APP_API_URL + "percepcion/pdf", {
                  token: this.$store.getters.userToken,
                  id: data.idPercepcion
                })
                .then(
                  response => (
                    (this.pdfobject = response.data.base64), (this.cargandopdf2 = false)
                  )
                )
                .catch(error => {});
            },
            downloadPdf: function(data) {
              let tag = document.createElement("i");
              tag.classList.add("fa", "fa-spin", "fa-spinner");
              let name = data.serie + "-" + data.numero + ".pdf";
              let file = "data:application/pdf;base64," + data.pdf;
              this.cargandopdf = true;
              this.$swal({
                title: "Procesando Descarga",
                content: tag,
                icon: "info",
                buttons: false,
                dangerMode: false
              });
              axios
                .post(process.env.VUE_APP_API_URL + "percepcion/pdf", {
                  token: this.$store.getters.userToken,
                  id: data.idPercepcion
                })
                .then(
                  response => (
                    (file = "data:application/zip;base64," + response.data.base64),
                    (this.cargandopdf = false),
                    download(file, name, "application/pdf"),
                    this.$swal.close()
                  )
                )
                .catch(error => {
                  this.$swal.close(),
                  this.$snotify.error(error.response.data.msg, 'Error')
                })
            },
            listPerception: function () {
                this.cargando = true;
                axios
                .post(process.env.VUE_APP_API_URL + "percepcion/listar", {
                    token: this.$store.getters.userToken,
                    page: this.currentPage,
                    limit: this.limite,
                    order: this.orden
                })
                .then(
                response => (
                    this.perceptions = response.data.data,
                    this.totalRows = this.perceptions.length,
                    this.total = response.data.total,
                    this.desde = response.data.from,
                    this.hasta = response.data.to,
                    this.cargando = false,
                    this.perceptions.forEach(function(element) {
                        element.loading = false;
                    })
                    // this.cargarPreview()
                )
                )
                .catch(error => {(this.cargando = false)});
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>